/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=8897a1ee&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=8897a1ee&scoped=true&lang=css"

import exportComponent from "D:\\daima\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8897a1ee"]])

export default __exports__